import { KEY } from '@/config'
let Protobuf = require('@/assets/js/rongIMLib/protobuf-2.3.7.min')

let RongIMClientInit = {
  methods: {
    IMInit(token, callbacks) {
      window.RongIMClient = RongIMLib.RongIMClient;
      const appKey = KEY.rongCloudAppKey;
      RongIMClient.init(appKey, null, {
        protobuf: Protobuf
      });
      let _this = this;
      // 链接状态监听
      RongIMClient.setConnectionStatusListener({
        onChanged(status) {
          // status 标识当前连接状态
          switch(status) {
            case RongIMLib.ConnectionStatus.CONNECTED:
              console.log('链接成功');
              let conversationTypes = [ RongIMLib.ConversationType.PRIVATE ];
              let count = 150;
              RongIMClient.getInstance().getConversationList({
                onSuccess(list) {
                  console.log('获取到了会话列表', list);
                  _this.$store.commit('setChatList', list);
                  // 删除数据出错的会话
                  // var conversationType = RongIMLib.ConversationType.PRIVATE
                  // var targetId = '4';
                  // RongIMClient.getInstance().removeConversation(conversationType, targetId, {
                  //   onSuccess: function(bool) {
                  //     console.log('删除指定会话成功');
                  //   },
                  //   onError: function(error) {
                  //     console.log('删除指定会话失败', error);
                  //   }
                  // });
                }
              }, conversationTypes, count)
              break;
            case RongIMLib.ConnectionStatus.CONNECTING:
              console.log('正在链接', status);
              break;
            case RongIMLib.ConnectionStatus.DISCONNECTED:
              console.log('断开连接', status);
              break;
            case RongIMLib.ConnectionStatus.KICKED_OFFLINE_BY_OTHER_CLIENT:
              console.log('其他设备登录, 本端被踢', status);
              break;
            case RongIMLib.ConnectionStatus.DOMAIN_INCORRECT:
              console.log('域名不正确', status);
              break;
            case RongIMLib.ConnectionStatus.NETWORK_UNAVAILABLE: {
              console.log('网络不可用', status);
              let callback = {
                onSuccess(userId) {
                  console.log('reconnect success. ' + userId);
                },
                onTokenIncorrect() {
                  console.log('token 无效');
                },
                onError(errorCode) {
                  console.log(errorcode);
                }
              };
              RongIMClient.reconnect(callback);
            }break;
            default:
              console.log('链接状态为', status);
              break;
          }
        }
      })

      // 消息接收监听
      RongIMClient.setOnReceiveMessageListener({
        // 接收到的消息
        onReceived(message) {
          console.log("新消息: " + message);
          let index = _this.$store.state.chatList.findIndex(item => {
            if(item.targetId == message.targetId) {
              return item;
            }
          })
          if(index != -1) {
            _this.$store.commit('updateLastMessage', {index: index, message: message});
          }else {
            let conversationTypes = [ RongIMLib.ConversationType.PRIVATE ];
            let count = 150;
            RongIMClient.getInstance().getConversationList({
              onSuccess(list) {
                console.log('获取会话列表,', list)
                _this.$store.commit('setChatList', list);
              }
            }, conversationTypes, count)
          }
          callbacks.receiveNewMessage && callbacks.receiveNewMessage(message);
        }
      })


      // 开启链接
      RongIMClient.connect(token, {
        onSuccess(userId) {
          console.log('连接成功, 用户 id 为', userId);
          let isCounted = true; // 消息计数
          let isPersited = true; // 消息保存
          let mesasgeTag = new RongIMLib.MessageTag(isCounted, isPersited);
          // 自定义问诊单卡片消息
          let AnwserMessageName = 'AnswerMessage';
          let AnwserObjectName = 'AnswerMsg';
          let AnwserPrototypes = ['username', 'sym_change', 'create_time', 'birthday', 'gender', 'id'];
          RongIMClient.registerMessageType(AnwserMessageName, AnwserObjectName, mesasgeTag, AnwserPrototypes);
          // 自定义处方卡片消息
          let PreMessageName = 'PreMessage';
          let PreObjectName = 'PreMsg';
          let PrePrototypes = ['username', 'type', 'diagnose', 'create_time', 'birthday', 'gender', 'id'];
          RongIMClient.registerMessageType(PreMessageName, PreObjectName, mesasgeTag, PrePrototypes);
          
          // 自定义转诊卡片消息
          let ReferMessageName = 'ReferMessage';
          let ReferObjectName = 'ReferMsg';
          let ReferPrototypes = ['username', 'reason', 'create_time', 'birthday', 'gender', 'id'];
          RongIMClient.registerMessageType(ReferMessageName, ReferObjectName, mesasgeTag, ReferPrototypes);
          callbacks.connectSuccess && callbacks.connectSuccess();
        },
        onTokenIncorrect() {
          console.log('连接失败, 失败原因: token 无效');
        },
        onError(errorCode) {
          console.log(errorCode)
        }
      })

      window.RongIMVoice = RongIMLib.RongIMVoice;
      RongIMVoice.init();
    }
  }
}

export default RongIMClientInit;



// WEBPACK FOOTER //
// ./src/untils/im.js